export { default } from "./Advantage";
